const usePhoneScreen = () => window.matchMedia('(max-width: 438px)').matches;

export default usePhoneScreen;
